import type { RuleEditorDropdownMode } from '../NodeEditorDrawer/types';

export const HIGHLIGHT_DROPDOWN_EVENT_KEY = 'highlightDropdown';

export interface HighlightDropdownEventPayload {
  index: {
    modeKey: RuleEditorDropdownMode.GROUP_END | RuleEditorDropdownMode.GROUP_START;
    path: string;
  };
  isHighlighted: boolean;
}
